export const menusArray = [
  {
    pageId: 1,
    name: "schedule",
    icon: "calendar alternate outline",
    title: "SCHEDULE",
    subMenus: [],
  },
  {
    pageId: 2,
    name: "dentists",
    customIcon: "imgDentist",
    title: "BY PROVIDER",
    subMenus: [],
  },
  {
    pageId: 3,
    name: "practice",
    icon: "building outline",
    title: "BY PRACTICE",
    subMenus: [],
  },
  {
    pageId: 4,
    name: "yearview",
    icon: "calendar check outline",
    title: "12 MONTHS VIEW",
    subMenus: [],
  },
  {
    pageId: 6,
    name: "manage-help",
    icon: "building outline",
    label: "PRACTICES",
    title: "Manage Help",
    subMenus: [],
    role: ["Admin"],
    hide: true,
  },
  {
    pageId: 11,
    name: "reports",
    icon: "chart bar outline",
    title: "REPORTS",
    subMenus: [
      {
        pageId: 12,
        name: "open-close-mismatch",
        icon: "iconTclosed",
        title: "OPEN CLOSED MISMATCH",
        subMenus: [],
      },
      {
        pageId: 13,
        name: "ts-te-mismatch",
        icon: "iconTclosedTS",
        title: "TS/TE MISMATCH REPORT",
        subMenus: [],
      },
      {
        pageId: 14,
        name: "doctor-work-history",
        icon: "clock",
        title: "DOCTOR WORK HISTORY REPORT",
        subMenus: [],
      },
      {
        pageId: 17,
        name: "schedule-change-comments",
        icon: "comments outline",
        title: "SCHEDULE CHANGE COMMENTS",
        subMenus: [],
      },
    ],
    role: ["Admin"],
  },
  {
    pageId: 7,
    name: "notes",
    icon: "sticky note outline",
    title: "NOTES",
    subMenus: [],
    role: ["Admin"],
  },
  {
    pageId: 16,
    name: "change-requests",
    icon: "exchange",
    title: "CHANGE REQUESTS",
    subMenus: [],
    permission: ["schedule-admin"],
  },
  {
    pageId: 15,
    name: "overrides",
    icon: "ban",
    title: "OVERRIDE DAYS",
    subMenus: [],
    role: ["Admin"],
  },
  {
    pageId: 8,
    name: "substitute-costs",
    icon: "money bill alternate outline",
    label: "Dentists Substitute Costs",
    title: "Dentists Substitute Costs",
    subMenus: [],
  },
  {
    pageId: 9,
    name: "default-sub-costs",
    icon: "money",
    label: "Default Substitute Costs",
    title: "Default Substitute Costs",
    subMenus: [],
    role: ["Admin"],
  },
  {
    pageId: 10,
    name: "usage",
    icon: "pie chart",
    label: "USAGE",
    title: "USAGE",
    subMenus: [],
    role: ["Admin"],
  },
];

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const HelpPages = {
  1: { name: "SCHEDULE" },
  2: { name: "BY PROVIDER" },
  3: { name: "BY PRACTICE" },
  4: { name: "OVERVIEW" },
  5: { name: "MOBILE" },
  140: { name: "CDP SCHEDULE - Reports > OPEN CLOSED MISMATCH REPORT" },
  141: { name: "CDP SCHEDULE - Reports > TS/TE MISMATCH REPORT" },
  142: { name: "CDP SCHEDULE - Reports > DOCTOR WORK HISTORY REPORT" },
  143: { name: "CDP SCHEDULE - Dentists Substitute Costs" },
  144: { name: "CDP SCHEDULE - Usage" },
};

export const userRoles = ["Admin", "View", "Doctor"];

export const hasMenuAccess = (menu, user) => {
  if (!menu.role && !menu.permission) return true;
  if (menu.role && menu.role.includes(user.srole)) return true;
  if (menu.permission && user.role && menu.permission.some(p => user.role.includes(p))) return true;
  return false;
};

export const openShiftClrCode = "#FACA12";
export const generalShiftClrCode = "#C6DB90";
export const oralOrthoShiftClrCode = "#73E1FC";
export const travelingShiftClrCode = "#F7EC93";

export const overrides = [
  { text: "Act of God", value: "Act of God", key: "Act of God" },
  { text: "Other", value: "Other", key: "Other" },
   { text: "Ortho", value: "Ortho", key: "Ortho" },
];

export const defaultPage = [
  { value: "schedule", text: "SCHEDULE" },
  { value: "dentists", text: "SCHEDULE BY PROVIDER" },
  { value: "practice", text: "SCHEDULE BY PRACTICE" },
  { value: "yearview", text: "12 MONTHS VIEW" },
  { value: "substitute-costs", text: "DENTISTS SUBSTITUTE COSTS" },
];

export const practiceInfoTimeArray = (startTime, endTime, intervalMinutes) => {
  const timeArray = [];

  const startMilliseconds = startTime * 3600000;
  const endMilliseconds = endTime * 3600000;

  for (
    let milliseconds = startMilliseconds;
    milliseconds <= endMilliseconds;
    milliseconds += intervalMinutes * 60000
  ) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = (milliseconds % 3600000) / 60000;
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

    timeArray.push({
      value: milliseconds.toString(),
      text: ` ${formattedTime}`,
    });
  }

  return timeArray;
};

export const RepeatOptionsList = [
  { value: "0", text: "Never" },
  { value: "1", text: "Every Week" },
  { value: "2", text: "Every 2 Weeks" },
  { value: "3", text: "Every 3 Weeks" },
  { value: "4", text: "Every 4 Weeks" },
  { value: "5", text: "Every 5 Weeks" },
  { value: "6", text: "Every 6 Weeks" },
  { value: "7", text: "Every 7 Weeks" },
  { value: "8", text: "Every 8 Weeks" },
];

export const baseDentistTypeList = [
  { text: "Select Type", value: "null" },
  { text: "General", value: "General" },
  { text: "Ortho", value: "Ortho" },
  { text: "Oral Surgery", value: "Oral Surgery" },
  { text: "Traveling Team", value: "Traveling Team" },
  { text: "Hygienists", value: "Hygienists" },
  { text: "Mentoring", value: "Mentoring" },
  { text: "Shadowing", value: "Shadowing" },
];

export const baseDentistSpecialityList = [
  { text: "Select Speciality", value: "" },
  { text: "Sedation", value: "Sedation" },
  { text: "GA", value: "GA" },
  { text: "TED", value: "TED" },
  { text: "Hygienists", value: "Hygienists" },
  { text: "Mentoring", value: "Mentoring" },
  { text: "Shadowing", value: "Shadowing" },
];

export const notesType = [
  { text: "Public", value: "Public" },
  { text: "Private", value: "Private" },
  { text: "Financial", value: "Financial" },
];

export const acceptHelpFileTypes = ".mp4, .pdf";
export const allowDeleteUserId = [163, 1710, 791, 1189, 1180];
export const udrPermissions = [
  { text: "All", value: "All", key: "All" },
  { text: "Admin", value: 1, key: "Admin" },
  { text: "Dentist", value: 2, key: "Dentist" },
  { text: "Orthodontics", value: 3, key: "Orthodontics" },
  { text: "Oral Surgeon", value: 4, key: "Oral Surgeon" },
  { text: "Traveling Team", value: 5, key: "Traveling Team" },
  { text: "Credentialing", value: 6, key: "Credentialing" },
  { text: "Hygienists", value: 7, key: "Hygienists" },
];
export const datePickerFormat = "MM-dd-yyyy";

export const notesFrequency = [
  { text: "First", value: "First", key: "First" },
  { text: "Second", value: "Second", key: "Second" },
  { text: "Split", value: "Split", key: "Split" },
];

export const deleteCookie = () => {
  const cookie1 = "cdp-cookie";
  document.cookie =
    cookie1 + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const validObj = (obj) =>
  !!obj && typeof obj === "object" && Object.keys(obj).length > 0;

export const SCHEDULE_NOTES_REQUIRED = [
  "id",
  "dentist",
  "bcare",
  "isTaxable",
  "dentistId",
  "title",
  "notesType",
  "desc",
  "practiceId",
  "practice",
  "financialNotes",
  "date",
  "sageAccount",
  "frequency",
  "dateString",
  "category",
  "procNum",
  "desc",
  "receipts",
    "documentation"
];


